import React from "react";
import "./customSoftwareDevelopment.css";
import customDevelopmentImage from "../../../assets/service-pictures/software-development.jpg";
import Particles from "../../Particles/Particles";
import HeroSection from "./HeroSection";
import OurApproach from "./OurApproach";
import EnsureSecurity from "./EnsureSecurity";
import IndustriesWeServe from "./IndustriesWeServe";
import Benefits from "./Benefits";
import CallToAction from "./CallToAction";

const CustomSoftwareDevelopment = () => {
  return (
    <div className="csd-service-wrapper">
      <Particles
        title="Custom Software Development"
        image={customDevelopmentImage}
      />
      <HeroSection />
      <OurApproach />
      <EnsureSecurity />
      <IndustriesWeServe />
      <hr />
      <Benefits />
      <CallToAction />
    </div>
  );
};

export default CustomSoftwareDevelopment;
